import Model, { attr, hasMany } from '@ember-data/model';
import { isEmpty } from '@ember/utils';
import { validator, buildValidations } from '@eflexsystems/ember-tracked-validations';
import { isHasManyRefDirty, rollbackHasMany } from 'eflex/util/relationship-helpers';

@buildValidations({
  code: [validator('presence', true)],
  description: [validator('presence', true)],
})
class Code extends Model {
  @attr('string') code;
  @attr('string') description;
  @attr('boolean', { defaultValue: false }) isFromSync;

  @hasMany('station', {
    async: false,
    inverse: 'codes',
    as: 'code',
  }) stations;

  get polymorphic() {
    return true;
  }

  get isDirty() {
    return super.isDirty || isHasManyRefDirty(this, 'stations');
  }

  get isGlobal() {
    return isEmpty(this.stations);
  }

  get stationIds() {
    return this.stations?.map(item => item.id) ?? [];
  }

  get displayName() {
    if (this.code == null || this.description == null) {
      return '';
    } else {
      return `${this.code} - ${this.description}`;
    }
  }

  rollbackAttributes() {
    rollbackHasMany(this, 'stations');
    super.rollbackAttributes();
  }
}

export default Code;
